const TwoDimensionalChartTypes = ['barchart', 'horizontalbarchart', 'donutchart', 'parliamentchart', 'piechart'];
const GroupedOrStackedTypes = ['groupedbarchart', 'stackedbarchart', 'bar-grouped-horizontal', 'bar-stacked-horizontal'];
const LineChartTypes = ['linechart', 'areachart', 'ttcharts-linechart'];

export enum FieldTypes {
  'miscField' = 'miscField',
  'isoLabelField' = 'isoLabelField',
  'timeField' = 'timeField',
  'valueField' = 'valueField',
  'isoField' = 'isoField',
}

export interface Dimension {
  dimName: string; // unique identifier
  dimLabel: string;
  fieldName: string;
  usedForUniqueness: boolean;
  requirements: {
    fieldTypes: Array<FieldTypes>;
  };
}

export interface Dimensions extends Array<Dimension> {}

export interface OldFields {
  labelField?: string;
  valueField?: string;
  aggregationField?: string;
  timeField?: string;
}

export const getOldFields = (type: string, dimensions: Dimensions): OldFields => {
  if (!type || !dimensions) return {};

  if (TwoDimensionalChartTypes.includes(type)) {
    return {
      labelField: dimensions.find((obj) => obj.dimName === 'xAxis')!.fieldName,
      valueField: dimensions.find((obj) => obj.dimName === 'yAxis')!.fieldName,
      aggregationField: undefined,
      timeField: undefined,
    };
  }

  if (GroupedOrStackedTypes.includes(type)) {
    return {
      labelField: dimensions.find((obj) => obj.dimName === 'xAxis')!.fieldName,
      valueField: dimensions.find((obj) => obj.dimName === 'yAxis')!.fieldName,
      aggregationField: dimensions.find((obj) => obj.dimName === 'groupAxis')!.fieldName,
      timeField: undefined,
    };
  }

  if (LineChartTypes.includes(type)) {
    return {
      timeField: dimensions.find((obj) => obj.dimName === 'xAxis')!.fieldName,
      valueField: dimensions.find((obj) => obj.dimName === 'yAxis')!.fieldName,
      labelField: dimensions.find((obj) => obj.dimName === 'labelAxis')!.fieldName,
      aggregationField: dimensions.find((obj) => obj.dimName === 'xAxis')!.fieldName,
    };
  }

  return {};
};
